(() => {
  document.addEventListener('invalid', (e) => {
    // prevents the browser from showing default error bubble / hint
    // optionally fire off some custom validation handler
    // myValidation();
    e.preventDefault();
  }, true);

  window.swinger.observer.initialize('.swinger-form', (elem) => {
    elem.setAttribute('novalidate', '');
  });

  let moveFocusTimer;
  const clearMoveFocusTimer = () => {
    window.clearTimeout(moveFocusTimer);
  };
  document.addEventListener('keydown', clearMoveFocusTimer);
  document.addEventListener('click', clearMoveFocusTimer);

  window.swinger.eventHub.register('submit', '.swinger-form', (e) => {
    const form = window.swinger.eventHub.getTarget(e);

    if (form.checkValidity && !form.checkValidity()) {
      form.classList.add('swinger-form--invalid');
      window.setTimeout(() => {
        form.classList.remove('swinger-form--invalid');
      }, 500);

      const fieldLabels = [];
      let firstInvalidElement;

      Array.prototype.slice.call(form.elements).forEach((elem) => {
        window.swinger.eventHub.trigger(elem, 'blur');
        if (elem.validity && !elem.validity.valid) {
          firstInvalidElement = firstInvalidElement || elem;

          if (elem.id && document.querySelector(`[for="${elem.id}"]`)) {
            const label = document.querySelector(`[for="${elem.id}"]`);
            fieldLabels.push(label.textContent.replace('*', '').trim());
          }
        }
      });

      window.swinger.i18n()
        .then((i18n) => {
          window.swinger.a11y.alert(i18n('ui.form.invalid-form-fields', {
            count: fieldLabels.length,
            fieldLabels: fieldLabels.join(','),
          }));

          if (firstInvalidElement) {
            window.setTimeout(() => {
              moveFocusTimer = window.setTimeout(() => {
                firstInvalidElement.focus();
              }, 1000);
            });
          }
        })
        .catch(console.log);

      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    const formUrl = new URL(form.action);
    const pageUrl = new URL(window.location);

    if (formUrl.origin === pageUrl.origin) {
      const csrfData = window.swinger.user.getCsrfData();

      if (csrfData.name && csrfData.value) {
        const csrfElem = form.querySelector(`input[name="${csrfData.name}"]`) || document.createElement('input');
        csrfElem.setAttribute('type', 'hidden');
        csrfElem.setAttribute('name', csrfData.name);
        csrfElem.setAttribute('value', csrfData.value);
        form.appendChild(csrfElem);
      }
    }

    window.setTimeout(() => {
      if (form.checkValidity && form.checkValidity()) {
        window.swinger.$('[type="submit"]', form).forEach((elem) => {
          elem.disabled = true;
        });
      }
    });
  });
})();
